import {
  Checkbox,
  Flex,
  FlexItem,
  FormElement,
  HelpIcon,
  InputNumber,
  Panel,
  RadioButton,
  RADIOBUTTON_LABEL_FW_STANDARD,
  Select,
  SPACING_16,
  SPACING_32,
  SPACING_40,
  SPACING_8,
  SpacingVertical,
  Text,
  TEXT_VARIANT_BOLD,
  Title,
  TITLE_VARIANT_M,
  TooltipUtils
} from 'mailup-web-components'
import {
  taskPanelFrequencyState,
  taskState
} from 'Pages/Task/recoil/state/task'
import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilState } from 'recoil'
import {
  CHOOSE_OPTIONS,
  DAYS,
  EVERY_HOUR_OPTIONS,
  EVERY_OPTIONS,
  MONTHS
} from './const'

const Days = () => {
  const intl = useIntl()
  const [task, setTask] = useRecoilState(taskState)
  // eslint-disable-next-line no-unused-vars
  const [taskPanelFrequency, setTaskPanelFrequency] = useRecoilState(
    taskPanelFrequencyState
  )

  const handleChange = (event, dayOfWeek) => {
    const choosenDays = task.Frequency.ChoosenDays.slice(0)
    const index = choosenDays.findIndex((e) => e.DayOfWeek === dayOfWeek)
    if (index > -1) {
      choosenDays.splice(index, 1)
    } else {
      choosenDays.push({
        DayOfMonth: 0,
        Month: 0,
        DayOfWeek: dayOfWeek,
        WeekOfMonth: '',
        FixedDay: false
      })
    }
    setTask((prev) => ({
      ...prev,
      Frequency: {
        ...prev.Frequency,
        ChoosenDays: choosenDays.filter((e) => e.DayOfWeek !== '')
      }
    }))
    setTaskPanelFrequency((prev) => ({
      ...prev,
      isDirty: true
    }))
  }

  return (
    <>
      <Text variant={TEXT_VARIANT_BOLD}>
        {intl.formatMessage({
          id: 'Load.Task.FrequencyMainSelectLabelDays'
        })}
      </Text>
      <SpacingVertical variant={SPACING_8} />
      <Flex justifyContent='space-between'>
        {DAYS.map((e) => (
          <Checkbox
            key={e.value}
            checked={
              task.Frequency.ChoosenDays.findIndex(
                (k) => k.DayOfWeek === e.value
              ) > -1
            }
            onChange={(evt) => handleChange(evt, e.value)}
            label={intl.formatMessage({
              id: e.label
            })}
            data-mu-test={`checkBox-${e}`}
          />
        ))}
      </Flex>
      <SpacingVertical variant={SPACING_32} />
    </>
  )
}

const Months = ({ montHasChanged }) => {
  const intl = useIntl()
  const [task, setTask] = useRecoilState(taskState)
  const [selectValue, setSelectValue] = useState({})
  // eslint-disable-next-line no-unused-vars
  const [taskPanelFrequency, setTaskPanelFrequency] = useRecoilState(
    taskPanelFrequencyState
  )

  const handleRadioButtonChange = (e) => {
    const choosenDay = task.Frequency.ChoosenDays.slice(0)
    const obj = Object.assign({}, choosenDay[0])
    obj.FixedDay = e

    setTask((prev) => ({
      ...prev,
      Frequency: {
        ...prev.Frequency,
        ChoosenDays: [obj]
      }
    }))
    setTaskPanelFrequency((prev) => ({
      ...prev,
      isDirty: true
    }))
  }

  const handleDayOfMonthChange = (e) => {
    if (e > 0 && e !== '') {
      const choosenDay = task.Frequency.ChoosenDays.slice(0)
      const obj = Object.assign({}, choosenDay[0])

      obj.DayOfMonth = e

      setTask((prev) => ({
        ...prev,
        Frequency: {
          ...prev.Frequency,
          ChoosenDays: [obj]
        }
      }))
      setTaskPanelFrequency((prev) => ({
        ...prev,
        isDirty: true
      }))
    }
  }

  const handleEveryWeekOfMonthChange = (e) => {
    setSelectValue({ filed: 'WeekOfMonth', value: e })
  }

  const handleEveryDayOfWeekChange = (e) => {
    setSelectValue({ filed: 'DayOfWeek', value: e })
  }

  useEffect(() => {
    montHasChanged !== -1 &&
      setSelectValue({ filed: 'Month', value: montHasChanged })
  }, [montHasChanged])

  useEffect(() => {
    if ('filed' in selectValue) {
      const choosenDay = task.Frequency.ChoosenDays.slice(0)
      const obj = Object.assign({}, choosenDay[0])
      if (selectValue.filed === 'DayOfWeek') {
        // obj.DayOfMonth = 0
        obj.FixedDay = false
        obj.DayOfWeek = selectValue.value
      } else if (selectValue.filed === 'WeekOfMonth') {
        // obj.DayOfMonth = 0
        obj.FixedDay = false
        obj.WeekOfMonth = selectValue.value
      } else if (selectValue.filed === 'Month') {
        obj.Month = +selectValue.value
      }
      setTask((prev) => ({
        ...prev,
        Frequency: {
          ...prev.Frequency,
          ChoosenDays: [obj]
        }
      }))
      setTaskPanelFrequency((prev) => ({
        ...prev,
        isDirty: true
      }))
    }
  }, [selectValue])

  return (
    <>
      <Text variant={TEXT_VARIANT_BOLD}>
        {intl.formatMessage({
          id: 'Load.Task.FrequencyMainSelectLabelDays'
        })}
      </Text>
      <SpacingVertical variant={SPACING_8} />
      <Flex alignItems='flex-start' columnGap='8px'>
        <FlexItem margin='8px 0 0 0'>
          <RadioButton
            value={1}
            checked={
              task.Frequency.ChoosenDays.length > 0 &&
              task.Frequency.ChoosenDays[0].FixedDay === true
            }
            label={intl.formatMessage({
              id: 'Load.Task.FrequencyMainSelectLabelDay'
            })}
            labelVariant={RADIOBUTTON_LABEL_FW_STANDARD}
            onChange={() => {
              handleRadioButtonChange(true)
            }}
            data-mu-test='PanelFrequency-nonth-FrequencyMainSelectLabelDay'
          />
        </FlexItem>
        <FormElement>
          <Flex display='block' width='70px'>
            <InputNumber
              disabled={
                task.Frequency.ChoosenDays.length === 0 ||
                task.Frequency.ChoosenDays[0].FixedDay === undefined ||
                task.Frequency.ChoosenDays[0].FixedDay === false
              }
              value={
                task.Frequency.ChoosenDays[0] &&
                task.Frequency.ChoosenDays[0].DayOfMonth
              }
              onChange={(e) => handleDayOfMonthChange(e)}
              min={1}
              max={31}
              precision={0}
            />
          </Flex>
        </FormElement>

        <FlexItem margin='8px 0 0 56px'>
          <RadioButton
            value={0}
            checked={
              task.Frequency.ChoosenDays.length > 0 &&
              task.Frequency.ChoosenDays[0].FixedDay === false
            }
            label={intl.formatMessage({
              id: 'Load.Task.FrequencyMainSelectLabelEvery'
            })}
            labelVariant={RADIOBUTTON_LABEL_FW_STANDARD}
            onChange={() => {
              handleRadioButtonChange(false)
            }}
            data-mu-test='PanelFrequency-nonth-FrequencyMainSelectLabelEvery'
          />
        </FlexItem>
        <FormElement
          feedback={
            task.Frequency.ChoosenDays.length > 0 &&
            task.Frequency.ChoosenDays[0].WeekOfMonth === '' &&
            task.Frequency.ChoosenDays[0].FixedDay === false
              ? intl.formatMessage({ id: 'Load.MailupCommon.Required' })
              : null
          }
        >
          <Flex display='block' minWidth='128px'>
            <Select
              error={
                task.Frequency.ChoosenDays.length === 0 ||
                (task.Frequency.ChoosenDays[0].WeekOfMonth === '' &&
                  task.Frequency.ChoosenDays[0].FixedDay === false)
                  ? 'danger'
                  : null
              }
              disabled={
                task.Frequency.ChoosenDays.length === 0 ||
                task.Frequency.ChoosenDays[0].FixedDay === undefined ||
                task.Frequency.ChoosenDays[0].FixedDay === true
              }
              value={
                task.Frequency.ChoosenDays[0] &&
                task.Frequency.ChoosenDays[0].WeekOfMonth
              }
              searchable={false}
              onChange={(e) => {
                handleEveryWeekOfMonthChange(e)
              }}
              options={EVERY_OPTIONS.map((e) => ({
                value: e.value,
                label: intl.formatMessage({ id: e.label })
              }))}
            />
          </Flex>
        </FormElement>

        <FormElement
          feedback={
            task.Frequency.ChoosenDays.length > 0 &&
            task.Frequency.ChoosenDays[0].DayOfWeek === '' &&
            task.Frequency.ChoosenDays[0].FixedDay === false
              ? intl.formatMessage({ id: 'Load.MailupCommon.Required' })
              : null
          }
        >
          <Flex display='block' minWidth='128px'>
            <Select
              error={
                task.Frequency.ChoosenDays.length === 0 ||
                (task.Frequency.ChoosenDays[0].DayOfWeek === '' &&
                  task.Frequency.ChoosenDays[0].FixedDay === false)
                  ? 'danger'
                  : null
              }
              disabled={
                task.Frequency.ChoosenDays.length === 0 ||
                task.Frequency.ChoosenDays[0].FixedDay === undefined ||
                task.Frequency.ChoosenDays[0].FixedDay === true
              }
              value={
                task.Frequency.ChoosenDays[0] &&
                task.Frequency.ChoosenDays[0].DayOfWeek
              }
              searchable={false}
              onChange={(e) => {
                handleEveryDayOfWeekChange(e)
              }}
              options={DAYS.map((e) => ({
                value: e.value,
                label: intl.formatMessage({ id: e.label })
              }))}
            />
          </Flex>
        </FormElement>
        <FlexItem margin='8px 0 0 0'>
          <Text>
            {intl.formatMessage({
              id: 'Load.Task.FrequencyMainSelectLabelEveryMonth'
            })}
          </Text>
        </FlexItem>
      </Flex>
      <SpacingVertical variant={SPACING_16} />
    </>
  )
}

Months.propTypes = {
  montHasChanged: PropTypes.any
}

const PanelFrequency = () => {
  const intl = useIntl()

  const [task, setTask] = useRecoilState(taskState)
  const [newMonth, setNewMonth] = useState(-1)
  const [taskPanelFrequency, setTaskPanelFrequency] = useRecoilState(
    taskPanelFrequencyState
  )

  useEffect(() => {
    TooltipUtils.rebuild()
    setTaskPanelFrequency((prev) => ({
      ...prev,
      radioAt: task.Frequency.DailyFrequency === 0
    }))
  }, [])

  const handleChangeActivites = (val) => {
    setTask((prev) => ({
      ...prev,
      Frequency: {
        ...prev.Frequency,
        KindDateFrequency: val,
        ChoosenDays: [
          {
            DayOfMonth: 1,
            Month: val === 'y' ? 1 : 0,
            DayOfWeek: val === 'w' ? '' : 'MO',
            WeekOfMonth: 'FIRST',
            FixedDay: true
          }
        ]
      }
    }))
    setTaskPanelFrequency((prev) => ({
      ...prev,
      isDirty: true
    }))
  }

  const handleChangeMonth = (val) => {
    setNewMonth(val)
  }

  const handleDateFrequency = (val) => {
    if (val > 0 && val !== '') {
      setTask((prev) => ({
        ...prev,
        Frequency: {
          ...prev.Frequency,
          DateFrequency: val
        }
      }))
      setTaskPanelFrequency((prev) => ({
        ...prev,
        isDirty: true
      }))
    }
  }

  const handleHourFrequency = (val) => {
    if (val > 0 && val !== '') {
      setTask((prev) => ({
        ...prev,
        Frequency: {
          ...prev.Frequency,
          DailyFrequency: val,
          StartHour: 0,
          StartMinute: 0
        }
      }))
      setTaskPanelFrequency((prev) => ({
        ...prev,
        isDirty: true
      }))
    }
  }

  const handleChangeHours = (val) => {
    if (val >= 0 && val !== '') {
      setTask((prev) => ({
        ...prev,
        Frequency: {
          ...prev.Frequency,
          DailyFrequency: 0,
          StartHour: val
        }
      }))
      setTaskPanelFrequency((prev) => ({
        ...prev,
        isDirty: true
      }))
    }
  }

  const handleChangeMinutes = (val) => {
    if (val >= 0 && val !== '') {
      setTask((prev) => ({
        ...prev,
        Frequency: {
          ...prev.Frequency,
          DailyFrequency: 0,
          StartMinute: val
        }
      }))
      setTaskPanelFrequency((prev) => ({
        ...prev,
        isDirty: true
      }))
    }
  }

  return (
    <Panel>
      <Title variant={TITLE_VARIANT_M}>
        {intl.formatMessage({ id: 'Load.Task.FrequencyTitle' })}
      </Title>
      <SpacingVertical variant={SPACING_40} />
      <Flex alignItems='center' columnGap='8px'>
        <Text>
          {intl.formatMessage({
            id: 'Load.Task.FrequencyMainSelectLabel'
          })}
        </Text>
        <FormElement>
          <Flex display='block' width='70px'>
            {task.Frequency.KindDateFrequency === 'd' && (
              <InputNumber
                min={1}
                max={31}
                precision={0}
                value={task.Frequency.DateFrequency}
                onChange={handleDateFrequency}
              />
            )}
            {task.Frequency.KindDateFrequency !== 'd' && (
              <InputNumber
                min={1}
                precision={0}
                value={task.Frequency.DateFrequency}
                onChange={handleDateFrequency}
              />
            )}
          </Flex>
        </FormElement>
        <FormElement>
          <Flex display='block' minWidth='128px'>
            <Select
              searchable={false}
              value={task.Frequency.KindDateFrequency}
              options={CHOOSE_OPTIONS.map((e) => ({
                value: e.value,
                label: intl.formatMessage({ id: e.label })
              }))}
              onChange={handleChangeActivites}
              data-mu-test='select-activites'
            />
          </Flex>
        </FormElement>
        {task.Frequency.KindDateFrequency === 'y' && (
          <>
            <Text>
              {intl.formatMessage({
                id: 'Load.Task.FrequencyMainSelectLabelMonth'
              })}
            </Text>

            <FormElement
              feedback={
                task.Frequency.ChoosenDays.length === 0 ||
                task.Frequency.ChoosenDays[0].Month === 0
                  ? intl.formatMessage({ id: 'Load.MailupCommon.Required' })
                  : null
              }
            >
              <Flex display='block' minWidth='128px'>
                <Select
                  searchable={false}
                  value={`${
                    task.Frequency.ChoosenDays[0] &&
                    task.Frequency.ChoosenDays[0].Month
                  }`}
                  options={MONTHS.map((e) => ({
                    value: e.value,
                    label: intl.formatMessage({ id: e.label })
                  }))}
                  onChange={handleChangeMonth}
                  data-mu-test='select-monts-in-year'
                  // placeholder={intl.formatMessage({
                  //   id: ''
                  // })}
                  error={
                    task.Frequency.ChoosenDays.length === 0 ||
                    task.Frequency.ChoosenDays[0].Month === 0
                      ? 'danger'
                      : null
                  }
                />
              </Flex>
            </FormElement>
          </>
        )}
      </Flex>
      <SpacingVertical />

      {task.Frequency.KindDateFrequency === 'w' && (
        <>
          <Days />
        </>
      )}
      {(task.Frequency.KindDateFrequency === 'm' ||
        task.Frequency.KindDateFrequency === 'y') && (
        <>
          <Months montHasChanged={newMonth} />
        </>
      )}

      <Text variant={TEXT_VARIANT_BOLD}>
        {intl.formatMessage({
          id: 'Load.Task.FrequencyMainSelectLabelTime'
        })}
      </Text>
      <SpacingVertical variant={SPACING_8} />
      <Flex alignItems='flex-start' columnGap='8px'>
        <FlexItem margin='8px 0 0 0'>
          <RadioButton
            value={'true'}
            checked={taskPanelFrequency.radioAt}
            label={intl.formatMessage({
              id: 'Load.Task.FrequencyMainSelectLabelHour'
            })}
            labelVariant={RADIOBUTTON_LABEL_FW_STANDARD}
            onChange={() => {
              setTaskPanelFrequency((prev) => ({
                ...prev,
                radioAt: true
              }))
              setTask((prev) => ({
                ...prev,
                Frequency: {
                  ...prev.Frequency,
                  DailyFrequency: 0
                }
              }))
            }}
            data-mu-test='PanelFrequency-FrequencyMainSelectLabelHour'
          />
        </FlexItem>
        <FormElement>
          <Flex display='block' width='70px'>
            <InputNumber
              min={0}
              max={23}
              precision={0}
              disabled={!taskPanelFrequency.radioAt}
              value={task.Frequency.StartHour}
              onChange={handleChangeHours}
            />
          </Flex>
        </FormElement>
        <FlexItem margin='8px 0 0 0'>:</FlexItem>
        <FormElement>
          <Flex display='block' width='70px'>
            <InputNumber
              min={0}
              max={59}
              step={5}
              precision={0}
              disabled={!taskPanelFrequency.radioAt}
              value={task.Frequency.StartMinute}
              onChange={handleChangeMinutes}
            />
          </Flex>
        </FormElement>
        <FlexItem margin='8px 0 0 56px'>
          <RadioButton
            value={'false'}
            checked={!taskPanelFrequency.radioAt}
            disabled={task.Frequency.IdFieldUTCCode > 0}
            label={intl.formatMessage({
              id: 'Load.Task.FrequencyMainSelectLabelEvery'
            })}
            labelVariant={RADIOBUTTON_LABEL_FW_STANDARD}
            onChange={() => {
              setTaskPanelFrequency((prev) => ({
                ...prev,
                radioAt: false
              }))
              setTask((prev) => ({
                ...prev,
                Frequency: {
                  ...prev.Frequency,
                  StartHour: 0,
                  StartMinute: 0
                }
              }))
            }}
            data-mu-test='PanelFrequency-FrequencyMainSelectLabelEvery'
          />
        </FlexItem>

        <FormElement
          feedback={
            task.Frequency.DailyFrequency === 0 && !taskPanelFrequency.radioAt
              ? intl.formatMessage({ id: 'Load.MailupCommon.Required' })
              : null
          }
        >
          <Flex display='block' minWidth='180px'>
            <Select
              value={task.Frequency.DailyFrequency}
              searchable={false}
              onChange={handleHourFrequency}
              options={EVERY_HOUR_OPTIONS.map((e) => ({
                value: e.value,
                label: intl.formatMessage({ id: e.label })
              }))}
              disabled={taskPanelFrequency.radioAt}
              error={
                task.Frequency.DailyFrequency === 0 &&
                !taskPanelFrequency.radioAt
                  ? 'danger'
                  : null
              }
            />
          </Flex>
        </FormElement>
        <FlexItem margin='10px 0 0 -8px'>
          <HelpIcon
            text={intl.formatMessage({
              id: 'Load.Task.FrequencyOnConflictTooltip'
            })}
          />
        </FlexItem>
      </Flex>
    </Panel>
  )
}

export default PanelFrequency
